import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "link"]

  connect() {
    // No longer auto-hide on outside clicks
    this.hideTimeout = null
  }

  disconnect() {
    // Cleanup timeout if it exists
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }
  }

  show(event) {
    event.preventDefault()
    event.stopPropagation()

    // Clear any pending hide timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }

    // Hide any other open menus
    document.querySelectorAll('[data-chatroom-context-menu-target="menu"]').forEach(menu => {
      menu.classList.add('d-none')
    })

    // Show this menu
    this.menuTarget.classList.remove('d-none')
    this.positionMenu()
  }

  showOnHover(event) {
    // Clear any pending hide timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }

    // Hide any other open menus
    document.querySelectorAll('[data-chatroom-context-menu-target="menu"]').forEach(menu => {
      menu.classList.add('d-none')
    })

    // Show this menu
    this.menuTarget.classList.remove('d-none')
    this.positionMenu()
  }

  hideOnLeave(event) {
    // Check if the mouse is moving to the menu
    const relatedTarget = event.relatedTarget
    const menu = this.menuTarget
    const controllerElement = this.element

    // If mouse is moving to the menu or any child of the controller element, don't hide
    if (relatedTarget) {
      if (menu.contains(relatedTarget) || controllerElement.contains(relatedTarget)) {
        return
      }
    }

    // Check if mouse is moving to chat header (don't hide if so)
    const chatHeader = document.querySelector('[id^="chat_header_"]')
    if (relatedTarget && chatHeader && (chatHeader.contains(relatedTarget) || chatHeader === relatedTarget)) {
      // Mouse is moving to chat header, hide menu immediately
      this.menuTarget.classList.add('d-none')
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout)
        this.hideTimeout = null
      }
      return
    }

    // Add a delay to allow mouse to reach the menu
    // Clear any existing timeout first
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }

    this.hideTimeout = setTimeout(() => {
      // Double check that mouse is not over menu, link, or controller element
      // Use a more reliable method to check hover state
      const mouseOverMenu = menu.matches(':hover')
      const mouseOverLink = this.linkTarget.matches(':hover')
      const mouseOverController = controllerElement.matches(':hover')

      if (!mouseOverMenu && !mouseOverLink && !mouseOverController) {
        this.menuTarget.classList.add('d-none')
      }
      this.hideTimeout = null
    }, 300) // 300ms delay - más tiempo para llegar al menú
  }

  menuEnter(event) {
    // Cancel hide if mouse enters menu
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
  }

  menuLeave(event) {
    // Check if mouse is moving back to the link
    const relatedTarget = event.relatedTarget
    const link = this.linkTarget
    const controllerElement = this.element

    // If mouse is moving back to link or controller element, don't hide
    if (relatedTarget && (link.contains(relatedTarget) || controllerElement.contains(relatedTarget))) {
      return
    }

    // Add a small delay before hiding
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }

    this.hideTimeout = setTimeout(() => {
      // Check if mouse is still over menu or link
      const mouseOverMenu = this.menuTarget.matches(':hover')
      const mouseOverLink = this.linkTarget.matches(':hover')

      if (!mouseOverMenu && !mouseOverLink) {
        this.menuTarget.classList.add('d-none')
      }
      this.hideTimeout = null
    }, 200)
  }

  hide(event) {
    event.preventDefault()
    event.stopPropagation()

    // Clear any pending timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }

    this.menuTarget.classList.add('d-none')
  }

  positionMenu() {
    // Position menu to the right of the chatroom item
    const linkRect = this.linkTarget.getBoundingClientRect()
    const menu = this.menuTarget

    menu.style.position = 'fixed'
    menu.style.left = `${linkRect.right + 10}px`
    menu.style.top = `${linkRect.top}px`
  }
}
